/*
 Browse

 Rezerwacje - z wykorzystaniem Redux (implementacja w appredux)
 Stan nawigacji: (store.pageState)
 Wywołanie akcji: ??store.dispatch(??
   Actions.nazwaAkcj(<parametry>));

 do zrobienia:
  - logowanie

 historia: 
  04-2019 JW - start
  03-05-2019 - połączenie z Redux
  20-05-209 - materialize
*/

import * as React from "react";

import { Theme, withStyles, WithStyles } from '@material-ui/core/styles';

import { AppState, Actions, store, DisplayState, IPageState } from '../appredux';

import { connect } from 'react-redux';

import { Trans, WithTranslation, withTranslation } from 'react-i18next';

import { Grid, Button, FormControl, FormLabel, Card, CardActionArea, CardActions, CardContent, Fab, Paper, Typography } from '@material-ui/core';
import ResponsiveImgMaterialUi from "responsive-img-material-ui";

import LocalDiningIcon from '@mui/icons-material/LocalDining';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';

import HomeIcon from '@mui/icons-material/Home';
import PersonIcon from '@mui/icons-material/Person';
import LockIcon from '@mui/icons-material/Lock';
//import StarsIcon from '@mui/icons-material/Stars';
import StarIcon from '@mui/icons-material/Star';
import CalculateIcon from '@mui/icons-material/Calculate';

import Zakladki, { Zakladka, } from './Zakladki';
import { Fragment } from "react";

import TextField from '@material-ui/core/TextField';

import LogoFooter from './LogoFooter';

import './style.css'
import Wyliczenia from "./Wyliczenia";
import theme from "themes";
import MuiTextField from "common/formFields/MuiTextField";

import SmsIcon from '@mui/icons-material/Sms';
import OknoKontakt from "./OknoKontakt";
import OknoTest from "./OknoTest";
import { sendErrorLog } from "common/helpers";

export const C06 = 30 //ILE_DNI_W_MIECIACU

interface MainProps {
 page: IPageState,
 windowWidth: number
}

interface MainState {
    zakladkaPrimary: number,

    openKontakt: boolean
    openTest: boolean
  
}

export type DaneZakladki = {
  C05: number,
  C07: number,
  C09: number,
  C13: number,
  C14: number,
  C18: number,
  C19: number,
  C20: number,
  pz: string,
}

let menuItemsPrimary : Zakladka[] =  [
    { value: 0, panelOpis1: "kontakt", panelOpis2: "", panelOpis3: "", color2: false, },
    { value: 1, panelOpis1: "test", panelOpis2: "", panelOpis3: "", color2: false },
]


class Main extends React.Component<WithStyles<typeof styles> & MainProps & WithTranslation, MainState>  {
  stylInputaIlePokoi: React.CSSProperties = { padding: "6px 14px", textAlign: "left", fontSize: "13px" };

    constructor(props: WithStyles<typeof styles> & MainProps & WithTranslation) {
        super(props, {});

        this.state = {
            zakladkaPrimary: 0,

            openKontakt: false,
            openTest: false
        }
    }

    async componentDidMount() {
       
    }

    componentWillUnmount() {
       
    }

  openOkno = (n: number) => {
    if(n === 0){
      this.setState({ openKontakt: true });
    } else 
    this.setState({ openTest: true });
  }  
  closeDialogKontakt = () => {
    this.setState({ openKontakt: false });
  }
  closeDialogTest = () => {
    this.setState({ openTest: false });
  };


 sendSms = async() => {
    try {
      // let res: Info = await obiektService.dajPortalInfo({
      //   hotelId: CONFIG.hotelID,
      //   domena: this.props.lang
      // }, {})

     
      // if(!res || (!res.kontaktTelefon && !res.kontaktEmail && !res.kontaktAdres) ){
      //   throw "brak danych"
      // }
 
     
      // await store.dispatch(Actions.pageState.setPreautoryzacja(preauto))

     
    } catch (error) {
      // await sendErrorLog("0", "-1", '/obiekt/dajPortalInfo')
      // await store.dispatch(Actions.pageState.addFcmLogMessage("/obiekt/dajPortalInfo", 2))
      // console.log(error)
    }
  }


  setPanelPrimary = async (panel: number) => {


    this.setState({
      zakladkaPrimary: panel,

    })

  }

   
    logoClick = () => {
      window.open("http://virtualsc.com.pl/")
    }

  

  preventKeys = (e: React.KeyboardEvent<HTMLDivElement>) => {
      if (e.key === "e" || e.key === "E" || e.key === "-" || e.key === "+") {
        e.preventDefault()
      }
  }

    render = () => {
        const { classes } = this.props;


        return (
            <Grid
                container
                spacing={8}
                className={classes.shadow}
                style={{marginTop: "40px", marginBottom: "20px"}}
                //direction="column"
                //alignItems="center"
                //justifyContent="center"
                //style={{ height: this.props.windowWidth > 600 ? (window.innerHeight - 4.8) + 'px' : '' }}
            >
              {/* , paddingTop: this.props.windowWidth > 960 ? "72px" : "0" */}
              {/* <Grid item xs={12} style={{ paddingTop: "55px", paddingBottom: "0px" }} > */}
                {/* <div style={{ padding: "20px 10px 10px", maxWidth: "300px", margin: 'auto', alignItems: "center" }} onClick={this.logoClick}>
                      <ResponsiveImgMaterialUi style={{ height: "100%", maxHeight: "65px", width: "78%", margin: "0 11%", cursor: "pointer" }}
                        xs={require('./logo_virtual.jpg').default}
                        md={require('./logo_virtual.jpg').default}
                        lg={require('./logo_virtual.jpg').default}
                      />
                    </div> */}

              

              {/* </Grid> */}

              {/* <span className={classes.shadow}> */}
                <Grid item xs={12} style={{ paddingBottom: "12px", paddingLeft: this.props.windowWidth < 1000 ? "24px" : "32px", paddingRight: this.props.windowWidth < 1000 ? "24px" : "32px" }}>
                  {/* <Typography variant="h5" component="h2" align="center" color="primary" style={{ fontSize: "15px", marginBottom: "10px" }} >
                    <b>{"obiekt"}</b>
                  </Typography> */}

                  <Grid container direction="row" alignItems='center' justifyContent="space-evenly" style={{   }}> {/*margin: "20px 0"*/}
                    {/* <Zakladki
                      windowWidth={this.props.windowWidth}

                      menuItemsPrimary={menuItemsPrimary}
                      panelPrimary={this.state.zakladkaPrimary}
                      setPanelPrimary={this.setPanelPrimary}
                      
                      openOkno={this.openOkno}
                    /> */}

                <Typography variant="h5" component="h2" align="center" color="primary" style={{ fontSize: "1.25rem", display: "flex", justifyContent: "center" }} >
                  <SmsIcon style={{ fontSize: "30px", paddingRight: "10px", marginTop: "-1px", color: "rgb(255, 165, 0)" }} />
                  <b>{"kontakt z VIRTUAL"}</b>
                </Typography>

                  </Grid>

                </Grid>

                <Grid item xs={12} style={{ padding: this.props.windowWidth < 1000 ? "0" : "0px"}}>
                  { this.state.zakladkaPrimary === 0 ?
                  <OknoKontakt open={this.state.openKontakt} send={this.sendSms}  close={this.closeDialogKontakt} windowWidth={this.props.windowWidth}/>
                  : null }
                   { this.state.zakladkaPrimary === 1 ?
                  <OknoTest open={this.state.openTest} send={this.closeDialogTest}  close={this.closeDialogTest} windowWidth={this.props.windowWidth}/>
                  : null }
                </Grid>

                {/* </span> */}

          
            {/* <Grid item xs={12} style={{ paddingTop: "0px", paddingBottom: "0px",  }}>
              <LogoFooter />
            </Grid> */}
               
            </Grid>
        )
    }
}


// połączenie z Redux
const mapStateToProps = (state: AppState) => ({
  page: state.pageState,
});

const styles = (theme: Theme) => ({
  card: {
    //boxShadow: '5px 5px 8px rgb(0 0 0 / 20%), 0px 0px 3px rgb(0 0 0 / 14%)',
    boxShadow: '0px 0px 10px rgb(0 0 0 / 20%), 0px 0px 10px rgb(0 0 0 / 14%), 0px 0px 10px rgb(0 0 0 / 12%)',
    borderRadius: 0,
    width: "90%", 
    maxWidth: '444px',
    margin: '25px auto 20px', 
    //"@media (max-width: 600px)": {
      //margin: '25px auto 20px',
    //}
  },
    icon: {
        color: theme.palette.error.main,
        //color: "white",
    },
    menuItemOrange: {
      //backgroundColor: "rgb(255, 165, 0)",
      backgroundColor: "white",
      "&:hover": {
        backgroundColor: "lavender",
        //backgroundColor: "rgb(178, 115, 0)",
        //backgroundColor: "rgba(0, 0, 0, 0.12)",
      },
    },
    menuItemWhite: {
      backgroundColor: "rgba(0, 0, 0, 0.12)",
      "&:hover": {
        backgroundColor: "lavender",
        //boxShadow: "0px 10px 13px -6px rgb(0 0 0 / 20%), 0px 20px 31px 3px rgb(0 0 0 / 14%), 0px 8px 38px 7px rgb(0 0 0 / 12%)"
      },
    },
    paper: {
      height: 150,
      border: "2px solid lavender",
      borderRadius: "0",
      //boxShadow: '5px 5px 8px rgb(0 0 0 / 20%), 0px 0px 3px rgb(0 0 0 / 14%)',
      //boxShadow: '0px 0px 10px rgb(0 0 0 / 20%), 0px 0px 10px rgb(0 0 0 / 14%), 0px 0px 10px rgb(0 0 0 / 12%)',
      //"@media (max-width: 600px)": {
      //  height: 150,
      //}
    },
    primary: {
        color: theme.palette.primary.main,
      },
  
      imgLogo:{
        maxWidth: '160px', 
        paddingTop: "10px",
        cursor: "pointer",
        marginRight: "-18px",
        "@media (max-width: 600px)": {
          maxWidth: '100px', 
          paddingTop: "5px",
        }
      },
      imgP24:{
        maxWidth: '120px',
        cursor: "pointer",
        marginLeft: "18px",
        "@media (max-width: 600px)": {
          maxWidth: '80px', 
        }
      },

      formControl: {
        //display: "block",
        //paddingBottom: "35px"
        marginTop: "0px", //4px
        display: "inline-flex" as "inline-flex",
        alignItems: "center" as "center",
        flexDirection: "row" as "row",   
    },
    border: {
      borderBottom: "1px solid rgba(224, 224, 224, 1)",
      width: "calc(90% + -80px)",
      position: "absolute" as "absolute",
      bottom: "0"
    },
    textField: {
      //color: "rgb(0, 0, 0)",
      //color: theme.palette.primary.main,
      //color: 'seagreen',
      padding: "8px 14px",
      fontSize: '16px',
      float: "left" as "left",
      textAlign: "left" as "left",
      fontWeight: "normal" as "normal"
      
    },
    textFieldDisabled: {
      color: theme.palette.primary.main,
    },
    textFieldEnabled: {
      //color: "orange",
      color: theme.palette.primary.main,
      fontWeight: "bold" as "bold"
    },
    inputWidth: {
      //width: "15%",
      width: "80px",
      display: "inline-flex" as "inline-flex"
    },
    label: {
      //color: theme.palette.primary.main,
      color: theme.palette.text.secondary,
      //fontFamilly: "sans-serif",
      //fontSize: "small"
      fontSize: "13px",
      fontFamily: "\"Arial\", \"Helvetica\", sans-serif",
      lineHeight: "20px",
      fontWeight: theme.typography.body2.fontWeight,
      paddingLeft: "20px",
      //padding: "7px 0 4px",

      //width: "85%",
      width: "calc(100% + -85px)",
      display: "inline-block" as "inline-block"
    },
    labelColor: {
      color: theme.palette.text.secondary,
    },
    labelDisabled: {
      color: "rgb(150, 150, 150)",
    },
    textButton: {
      //marginLeft: "20px",
      marginRight: "-2px",
      textTransform: "none" as "none",
      fontSize: "14px",
      padding: "2px 15px",
      width: "80px"
      //paddingLeft: "20px", 
      //paddingRight: "20px", 
      //color: theme.palette.error.main, 
      // cursor: "pointer",
      // "&:hover": {
      //     color: "rgb(178, 115, 0)", 
      //   },
    },
    shadow: {
      boxShadow: "0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)",
      //borderRadius: "4px"
    }


});

export default connect(mapStateToProps)(withTranslation()(withStyles(styles)(Main)));
